// ---------------------------------------------------------------
//  Credit‑card recommendation logic (fixed)
// ---------------------------------------------------------------

function getRecommendedCards(answers) {
  const cards = [];

  // -----------------------------------------------------------
  //  1️⃣  条件：年会費が無料で、ポイント還元が高いカードを探す
  // -----------------------------------------------------------
  if (answers.annualFee === 'free' && answers.priority === 'points') {
    cards.push({
      rank: 1,
      name: 'dカード',
      reason: '学生でも申込可能で、年会費永年無料。dポイントが貯まりやすく、ローソンで最大5.0%お得。スマホ決済との相性も良く、普段使いに最適です。',
      cashback: '1.0%～5.0%',
      annualFee: '永年無料',
      features: ['学生OK', 'ローソンで5.0%お得', 'd払いで1.5%還元'],
      link: '/dcard',
      campaign: '最大4,000ポイントプレゼント'
    });

  // -----------------------------------------------------------
  //  2️⃣  条件：ベネフィット（特典・保険）が重要なユーザー
  // -----------------------------------------------------------
  } else if (answers.priority === 'benefits') {
    cards.push({
      rank: 1,
      name: '三井住友カード ゴールド(NL)',
      reason: '年間100万円利用で翌年以降年会費永年無料。最高2,000万円の海外旅行傷害保険付帯。空港ラウンジも無料で利用でき、旅行好きに最適なゴールドカードです。',
      cashback: '0.5%～7.0%',
      annualFee: '5,500円（条件達成で永年無料）',
      features: ['海外旅行保険最高2,000万円', '空港ラウンジ無料', 'コンビニで7.0%還元'],
      link: '/mitsui',
      campaign: '新規入会で最大9,000円相当プレゼント'
    });
    cards.push({
      rank: 2,
      name: '農協系カード',
      reason: '農協グループ店舗で特典が充実。直売所で5%割引、ガソリンスタンドで2円引き。旅行保険も自動付帯で安心です。',
      cashback: '0.5%～1.0%',
      annualFee: '初年度無料（2年目以降1,375円）',
      features: ['直売所で5%割引', 'ガソリン2円引き', '旅行保険自動付帯'],
      link: '/ja',
      campaign: '入会で最大5,000ポイントプレゼント'
    });

  // -----------------------------------------------------------
  //  3️⃣  条件：年会費が OK かつセキュリティ（デポジット）が重要
  // -----------------------------------------------------------
  } else if (answers.annualFee === 'ok' && answers.priority === 'security') {
    // デポジット型カードを推薦する新しい条件分岐
    cards.push({
      rank: 1,
      name: 'デポジット型クレジットカード',
      reason: 'デポジット（保証金）を預けることで利用できるクレジットカード。審査が不安な方でも作りやすく、デポジット額が利用限度額になるため使いすぎの心配もありません。',
      cashback: '0.5%',
      annualFee: '1,375円（税込）',
      features: ['審査が柔軟', 'デポジット5万円〜200万円', 'ETCカード発行可能'],
      link: '/nexus',
      campaign: 'デポジット型で安心してご利用いただけます'
    });
    cards.push({
      rank: 2,
      name: '大手ECモール系カード',
      reason: '年会費永年無料で還元率1.0%。ECモールでは3.0%以上の高還元率を実現。ポイントは使い道が豊富で、初めてのクレジットカードとしても最適です。',
      cashback: '1.0%～3.0%',
      annualFee: '永年無料',
      features: ['ECモールで3.0%還元', 'ペイで1.5%還元', '新規入会で8,000ポイント'],
      link: '/ec-mall-card',
      campaign: '今なら新規入会で8,000ポイントプレゼント'
    });

  // -----------------------------------------------------------
  //  4️⃣  デフォルト：条件に合致しない場合のフォールバック
  // -----------------------------------------------------------
  } else {
    // ここにデフォルトカードやエラーハンドリングを入れることができます。
    console.warn('No matching recommendation branch for the provided answers.');
  }

  return cards;
}

// ---------------------------------------------------------------
//  エクスポート（必要に応じて）
// ---------------------------------------------------------------
export default getRecommendedCards;
